import React from 'react';
import InContainer from '../layout/InContainer';
import WithFooter from '../layout/WithFooter';

function PageLayout(props) {
    if (props.isEmbedded === true) {
        return <InContainer margined={false}>{props.children}</InContainer>
    }
    return <WithFooter>{props.children}</WithFooter>
}

export default PageLayout;